module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title-login":"Anmeldung"},"fr":{"title-login":"Inscription"},"it":{"title-login":"Registrazione"}}')
  delete Component.options._Ctor
}
